<template>
    <v-alert colored-border border="right" :color="primaryColor"
             class="mt-4 form-container mr-auto ml-auto cgu-alert">
        <div class="d-flex cgu-box">
            <div class="mt-auto mb-auto">
                <v-checkbox class="mt-0 mr-3 custom-checkbox" :value="acceptCgu"
                            @change="checkCgu" :color="primaryColor"
                            hide-details>
                </v-checkbox>
            </div>
            <div>
                <span>Je certifie avoir lu et accepté </span>
                <a class="text-decoration-underline" :style="'color:' + primaryColor + '!important'" :href="cgu" target="_blank">
                    Les Conditions d'utilisation ainsi que le Règlement sur le respect de la vie privée
                </a>
                <span> de {{ organism }}</span>
            </div>
        </div>
    </v-alert>
</template>

<script>
import {mapMutations, mapState} from "vuex"

export default {
    name: "CmajFormCgu",
    props: ['cgu', 'organism'],
    methods: {
        ...mapMutations('web_form', ['setAcceptCgu']),
        checkCgu(value) {
            this.setAcceptCgu(Boolean(value))
        }
    },
    computed: {
        ...mapState('webFormStyle', ['primaryColor']),
        ...mapState('web_form', ['acceptCgu']),
    }
}
</script>